const DEFAULT_COLOR_PICKER_COLOR = { hex: '#dadadaff' };


export default DEFAULT_COLOR_PICKER_COLOR;
